let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aAusY")).then(() => parcelRequire('UuiVi'));